import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function createMapForCache(initialCapacity) {
  return HashMap().new_kotlin_collections_HashMap_5ewlp_k$(initialCapacity);
}
//region block: exports
export {
  createMapForCache as createMapForCache33nwboubq6azo,
};
//endregion

//# sourceMappingURL=createMapForCache.mjs.map
